export async function getSearchToken(user) {
  try {
    const response = await fetch(`/coveo/token?email=${user}`);
    return await response.json();
  } catch (error) {
    return null;
  }
}
